import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";

import { LayoutSplashScreen } from "../_metronic/layout";
import AccountsRoutes from "./Accounts";
import SenderIdsRoutes from "./SenderId";
import GatewayAndPriceRoutes from "./GatewayAndPrice";
import GatewayNameRoutes from "./GatewayName";
import CampaignLiveStatus from "./campaign-live-status";
import CampaignLiveStatusV2 from "./campaign-live-status-v2";
import WalletHistoryRoutes from "./Wallet-history";
import VerifyNumberContainer from "./Number-verify";
import WhatsAppAccounts from './WhatsAppAccounts';
import AdminAnalyticsRoutes from "./AdminAnalytics";
import PaymentLogsRoutes from "./Payment-logs";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact from="/" to="/admin-analytics" />
        <Route path="/accounts" component={AccountsRoutes} />
        <Route path="/senderIds" component={SenderIdsRoutes} />
        <Route path="/gateway-and-price" component={GatewayAndPriceRoutes} />
        <Route path="/gateway-name" component={GatewayNameRoutes} />
        <Route path="/campaign-live-status-v2" component={CampaignLiveStatusV2} />
        <Route path="/campaign-live-status" component={CampaignLiveStatus} />
        <Route path="/wallet-history" component={WalletHistoryRoutes} />
        <Route path="/number-verify" component={VerifyNumberContainer} />
        <Route path="/whatsapp-accounts" component={WhatsAppAccounts} />
        <Route path="/admin-analytics" component={AdminAnalyticsRoutes} />
        <Route path="/payment-logs" component={PaymentLogsRoutes} />
        <Redirect to="/error/error-v6" />
      </Switch>
    </Suspense>
  );
}
